import translate from "@insite/client-framework/Translate";
import { AttributeTypeFacetModel } from "@insite/client-framework/Types/ApiModels";
import { GridItemProps } from "@insite/mobius/GridItem";
import Select, { SelectProps } from "@insite/mobius/Select";
import React, { useEffect } from "react";
import { css } from "styled-components";


export interface YearPickerProps {
    yearFacet?: AttributeTypeFacetModel;
    /** Years that can be clicked / selected */
    enabledYears?: number[];
    /** Currently-selected year (optional) */
    selectedYear?: string;
    /** Earliest year to show (defaults to 1890 or the earliest enabled year) */
    minYear?: number;
    /** Latest year to show (defaults to the current year) */
    maxYear?: number;
    /** Callback when the user chooses a year */
    onYearSelect: (year: string) => void;

    isEnabled?: boolean;
}
export interface YearPickerStyles {

    yearpickerGridItem?: GridItemProps;
    decadeRow?: GridItemProps;
    decadeCell?: GridItemProps;
    yearsGrid?: GridItemProps;
    yearRow?: GridItemProps;
    yearCell?: GridItemProps;
    yearCellEnabled?: GridItemProps;
    yearCellEnabledHover?: GridItemProps;
    yearCellDisabled?: GridItemProps;
    yearCellSelected?: GridItemProps;

}

export const yearPickerStyles: YearPickerStyles = {

    yearpickerGridItem: {
        css: css``,
    },
    decadeRow: {
        css: css`
       `,
    },
    decadeCell: {
        css: css`
       
    }
        `,
    },
    yearsGrid: {
        css: css`       
      
        `,
    },
    yearRow: {
        css: css`
         
    `,
    },
    yearCell: {
        css: css`
        
    `,
    }
};

export const YearPicker: React.FC<YearPickerProps> = ({
    yearFacet,
    selectedYear,
    onYearSelect,
    isEnabled
}) => {
    const [years, setYears] = React.useState<{ attributeValueId: string; value: string }[]>([]);


    useEffect(() => {
        if (yearFacet?.attributeValueFacets) {
            const sortedYears = [...yearFacet.attributeValueFacets]
                .sort((a, b) => Number(b.value) - Number(a.value));
            setYears(sortedYears);
        }
    }, [yearFacet])

    const handleStateChange: SelectProps["onChange"] = event => {
        onYearSelect(event.target.value);
    }

    return (
        <Select
            name="year"
            value={selectedYear}
            data-test-selector="createAccount_country"
            onChange={handleStateChange}
            disabled={!isEnabled}
        >
            <option value="">{translate("Year")}</option>

            {years.map((row) => (
                <option key={row.attributeValueId} value={row.attributeValueId}>
                    {row.value}
                </option>
            ))}

        </Select>
    )

};
